import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import CustomersActionCreators from 'actions/CustomersActionCreators';
import UserActionCreators from 'actions/UserActionCreators';
import MarketActionCreators from 'actions/MarketActionCreators';
import store from 'stores/CustomerDetailsStore';
import ToastStore from 'stores/ToastStore';
import StripeStore from 'stores/StripeTransactionsStore';
import SessionStore from 'stores/SessionStore';
import UserWebAPIUtils from 'utils/UserWebAPIUtils';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';
import { withTranslation } from 'react-i18next';
import USER_TYPES from 'constants/UserTypes';
import ShipperDetails from './shipper/shipper-details';
import CarrierDetails from './carrier/CarrierDetails';
import ConsigneeDetails from './consignee/consignee-details';
import CarrierCenter from '../carrier/CarrierCenter';
import DriverDetails from './driver/driver-details';
import VendorDetails from './vendor/vendor-details';
import ChangePasswordModal from './change-password-modal';
import AdminEditProfileModal from './admin-edit-profile-modal';
import AdminDetails from './admin/admin-details';
import WarehouseUserDetails from './warehouse/admin-warehouse-details';

export function onSaveCustomerDetails(type, data) {
  let allowedFields = [];
  const details = {};

  if (type === 'Shipper') {
    allowedFields = [
      '_id',
      'origin',
      'destination',
      'affiliates',
      'accounting',
      'address',
      'beta_tester',
      'can_pay_manually',
      'carrier_partners',
      'company_name',
      'email',
      'project',
      'enterprise',
      'excluded_carriers',
      'first_name',
      'industry',
      'last_name',
      'markup',
      'phone',
      'phone_extension',
      'preferred_carrier',
      'invoice_schedule',
      'sales_rep',
      'billing_rep',
      'account_manager',
      'operations_manager',
      'test',
      'can_view_quotes',
      'strategic_shipper',
      'fragile_shipments',
      'carriers',
      'premium_shipper',
      'cargomatic_transport',
      'require_tracking_id',
      'black_and_white_invoices',
      'email_format',
      'invoice_entity',
      'business',
      'location_name',
      'requires_signature_capture',
      'status',
      'net_suite_id',
      'primary_reference_field',
      'drayage_terms',
      'shorthaul_terms',
      'container_edi_events',
      'drayage_payment_method',
      'shorthaul_payment_method',
      'group_like_invoice_items',
      'data_entry_agent',
      'customer_success_manager',
      'operations_group',
      'account_support_agent',
      'account_support_agent_tier2',
      'yard_free_days',
      'drayage_invoice_branding',
      'drayage_blling_time_frame',
      'linesOfBusiness',
      'crm_mapping_id',
      'hide_column_properties',
    ];
  } else if (type === 'Carrier') {
    allowedFields = [
      '_id',
      'address',
      'all_banking_info_approved',
      'authorized',
      'beta_tester',
      'dot_number',
      'email',
      'enterprise',
      'first_name',
      'has_flatbed_trucks',
      'hazmat_certified',
      'is_dray',
      'is_owner_operator',
      'last_name',
      'last_name',
      'linesOfBusiness',
      'service_type',
      'markets',
      'name',
      'phone',
      'phone_extension',
      'preferred_carrier',
      'sales_rep',
      'tags',
      'test',
      'is_broker',
      'tsa_certified',
      'email_format',
      'scac_code',
      'primary_scac_code',
      'edi_version',
      'customer_configurations',
      'drayage_terms',
      'shorthaul_terms',
      'drayage_payment_method',
      'shorthaul_payment_method',
      'group_like_payout_items',
      'data_entry_agent',
      'account_support_agent',
      'carrier_success_manager',
      'crm_mapping_id',
      'bank_verified',
    ];
  } else if (type === 'Driver') {
    allowedFields = [
      '_id',
      'address',
      'authorized',
      'available',
      'beta_tester',
      'cdl',
      'email',
      'first_name',
      'last_name',
      'phone',
      'phone_extension',
      'test',
      'username',
      'dispatch',
      'badges',
    ];
  } else if (type === 'Vendor') {
    allowedFields = [
      '_id',
      'address',
      'email',
      'first_name',
      'last_name',
      'phone',
      'phone_extension',
      'username',
    ];
  } else if (type === 'Admin') {
    allowedFields = ['_id', 'email', 'first_name', 'last_name'];
  }

  _.keys(data).forEach((key) => {
    if (allowedFields.indexOf(key) !== -1) {
      let value = data[key];
      if (key === 'email') {
        value = (value || '').trim().toLowerCase();
      }
      details[key] = value;
    }
  });
  CustomersActionCreators[`update${type}`](details);
}

function onSaveOrigin(data) {
  console.log('DATA', data);
  CustomersActionCreators.createOrigin(data);
}

function onSaveDestination(data) {
  CustomersActionCreators.createDestination(data);
}

function onSaveBillingAddress(type, data) {
  CustomersActionCreators[`update${type}`]({
    _id: store.details._id,
    billing_address: data,
  });
}

function getStripeTransactions() {
  const details = store.details;
  let id;
  if (!details) {
    return;
  }
  // If there is a stripe id and it is not in the stripe store, update transactions
  if (details._type === 'Shipper' && details.stripe_customer_id) {
    id = details.stripe_customer_id;
    if (id !== StripeStore.get('id')) {
      CustomersActionCreators.getStripeCharges(id);
    }
  } else if (details._type === 'Carrier' && details.stripe_account_id) {
    id = details.stripe_customer_id;
    if (id !== StripeStore.get('id')) {
      CustomersActionCreators.getStripePayouts(id);
    }
  }
}

function onLogoUpdate() {
  const notifications = ToastStore.getNotifications();
  notifications.push({ title: 'Logo updated', body: '', level: 'success' });
  ToastStore.emitChange();
}

function onUpdateDriver(data) {
  CustomersActionCreators.updateDriver(data);
}

function onAddCarrierDriver(data) {
  CustomersActionCreators.createDriver(data);
}

function onAddDefaultDriver() {
  CustomersActionCreators.createDefaultDriver(store.details._id);
}

function onSaveCreditCard(data) {
  data.userId = store.details._id;
  CustomersActionCreators.updateCreditCard(data);
}

function onSaveBankAccount(data) {
  data.userId = store.details._id;
  CustomersActionCreators.createBankAccount(data);
}

function onMakeDriverDefault(driverId) {
  const update = Object.assign({}, store.details, { default_driver: driverId });
  CustomersActionCreators.updateCarrier(update);
}

class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authorizing: false,
      stripeTransactions: false,
      showChangePasswordModal: false,
      showAccountRequestModal: false,
      showEditProfileModal: false,
    };
  }

  async componentDidMount() {
    const user = SessionStore.getUser();
    // Fetch customer details
    if (SessionStore.isAdmin()) {
      CustomersActionCreators.getCustomer(this.props.match.params.id);
    } else {
      CustomersActionCreators.getCustomer(user._id);
    }

    // Refresh markets, sales people, carriers and shippers
    MarketActionCreators.getAllMarkets();
    if (SessionStore.isAdmin()) {
      UserActionCreators.getSalespeople();
      CustomersActionCreators.getCarriers();
      CustomersActionCreators.getShippers({
        per_page: 100,
        sort_by: 'first_name',
      });
    }

    // We refresh every time the store changes
    const me = this;
    this.refresh = () => {
      me.checkAuthorizing();
      getStripeTransactions();
      me.forceUpdate();
    };
    // Make store listen to dispatch
    store.addChangeListener(this.refresh);

    this.refreshTransactions = () => {
      let transactions = false;
      if (!StripeStore.get('loading')) {
        transactions = StripeStore.get('transactions');
      }

      me.setState({ stripeTransactions: transactions });
    };
    StripeStore.on('change', this.refreshTransactions);
  }

  componentWillUnmount() {
    StripeStore.off('change', this.refreshTransactions);
    store.removeChangeListener(this.refresh);
  }

  handleAccountAccessRequest = async () => {
    const { details } = store;

    try {
      await UserWebAPIUtils.createSupportRequest(
        SessionStore.getUser()._id,
        details.email,
        details._id,
      );
    } catch (e) {
      console.log('Error creating support request', e.message);
    }
    this.hideAccountRequestModal();
  };

  onOpenJobs(type) {
    return () => {
      const qs = `${type}[0]=${store.details._id}`;
      if (typeof this.props.history.push === 'function') {
        this.props.history.push(`/shipments?${qs}`);
      } else if (typeof this.props.history.pushState === 'function') {
        this.props.history.pushState(null, '', `/shipments?${qs}`);
      }
    };
  }

  showAccountRequestModal = () => {
    this.setState({ showAccountRequestModal: true });
  };

  hideEditProfileModal = () => {
    this.setState({ showEditProfileModal: false });
  };

  hideAccountRequestModal = () => {
    this.setState({ showAccountRequestModal: false });
  };

  onUpdatePassword(password) {
    CustomersActionCreators.updatePassword(store.details._id, password);
  }

  onUpdateProfile = async (userData) => {
    onSaveCustomerDetails('Admin', userData);
    this.setState({ showEditProfileModal: false });
  };

  onSaveConsigneeDetails = async (consignee) => {
    await CustomersAPIUtils.updateConsignee(consignee);
  };
  // eslint-disable-next-line
  checkAuthorizing() {
    const { t } = this.props;
    if (this.state.authorizing) {
      const details = store.details;
      const de = details.authorized ? '' : 'de';
      const message = t('CUSTOMER_WAS_AUTHORIZED', { name: details.name, de });
      const notifications = ToastStore.getNotifications();

      notifications.push({ title: message, body: '', level: 'success' });
      ToastStore.emitChange();

      if (this.state.authorizing) {
        this.setState({ authorizing: false });
      }
    }
  }

  render() {
    const { t } = this.props;
    if (SessionStore.isCarrier()) {
      return <CarrierCenter />;
    }

    if (store.loading) return <p className="lead">{t('LOADING')}</p>;

    const details = store.details;
    const id = this.props.match.params.id;

    if (!details) {
      return <p className="lead">{t('LOADING')}</p>;
    }

    if (id && id !== details?._id) {
      return null;
    }

    let form;

    if (details._type === 'Admin') {
      form = (
        <AdminDetails
          user={details}
          onEditProfileClick={() => {
            this.setState({ showEditProfileModal: true });
          }}
          onChangePasswordClick={() => {
            this.setState({ showChangePasswordModal: true });
          }}
        />
      );
    } else if (details._type === 'Shipper') {
      form = (
        <ShipperDetails
          details={details}
          transactions={this.state.stripeTransactions}
          onOpenPassword={() => {
            this.setState({ showChangePasswordModal: true });
          }}
          onOpenAccountRequest={this.showAccountRequestModal}
          onSaveDetails={onSaveCustomerDetails}
          onSaveOrigin={onSaveOrigin}
          onSaveDestination={onSaveDestination}
          onLogoUpdate={onLogoUpdate}
          onSaveCreditCard={onSaveCreditCard}
          onSaveBillingAddress={onSaveBillingAddress}
          onOpenJobs={this.onOpenJobs('shipper')}
          onCustomerPreferencesChange={CustomersActionCreators.updateShipper}
        />
      );
    } else if (details._type === 'Carrier') {
      form = (
        <CarrierDetails
          details={details}
          transactions={this.state.stripeTransactions}
          onOpenPassword={() => {
            this.setState({ showChangePasswordModal: true });
          }}
          onOpenAccountRequest={this.showAccountRequestModal}
          onSaveDetails={onSaveCustomerDetails}
          onSaveBillingAddress={onSaveBillingAddress}
          onSaveBankAccount={onSaveBankAccount}
          onAddDriver={onAddCarrierDriver}
          onAddDefaultDriver={onAddDefaultDriver}
          onUpdateDriver={onUpdateDriver}
          onOpenJobs={this.onOpenJobs('carrier')}
          onMakeDefault={onMakeDriverDefault}
        />
      );
    } else if (details._type === 'Vendor') {
      form = (
        <VendorDetails
          details={details}
          onChangePasswordClick={() => {
            this.setState({ showChangePasswordModal: true });
          }}
          onSaveDetails={onSaveCustomerDetails}
        />
      );
    } else if (details._type === 'Consignee') {
      form = (
        <ConsigneeDetails
          consignee={details}
          onChangePasswordClick={() => {
            this.setState({ showChangePasswordModal: true });
          }}
          onSaveDetails={this.onSaveConsigneeDetails}
        />
      );
    } else if (details._type === USER_TYPES.WAREHOUSE) {
      form = (
        <WarehouseUserDetails
          details={details}
          onOpenPassword={() => {
            this.setState({ showChangePasswordModal: true });
          }}
        />
      );
    } else {
      form = (
        <DriverDetails
          details={details}
          onChangePasswordClick={() => {
            this.setState({ showChangePasswordModal: true });
          }}
          onSaveDetails={onSaveCustomerDetails}
          onOpenJobs={this.onOpenJobs('driver')}
        />
      );
    }

    return (
      <div className="py-4">
        {form}
        <ChangePasswordModal
          show={this.state.showChangePasswordModal}
          onHide={() => this.setState({ showChangePasswordModal: false })}
          onSave={this.onUpdatePassword}
        />
        {this.state.showAccountRequestModal && (
          <ConfirmModal
            show={this.state.showAccountRequestModal}
            title={t('REQUEST_ACCOUNT_ACCESS')}
            message={t('REQUEST_PERMISSION_TO_LOG_IN_TIP')}
            hideButtonText={t('CANCEL')}
            affirmative={t('OK')}
            onConfirm={this.handleAccountAccessRequest}
            onHide={this.hideAccountRequestModal}
          />
        )}
        <AdminEditProfileModal
          show={this.state.showEditProfileModal}
          user={details}
          onHide={this.hideEditProfileModal}
          onSave={this.onUpdateProfile}
        />
      </div>
    );
  }
}

UserDetails.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withTranslation()(UserDetails);
